export const IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const RESTAURANT_INFO_URL =
  "https://demo9015506.mockable.io/restaurantInfo/";

export const RESTAURANTS_URL = "https://demo9015506.mockable.io/getRestaurants";
